// src/types.ts
import { LogLevel } from "@loglayer/shared";
var PluginCallbackType = /* @__PURE__ */ ((PluginCallbackType2) => {
  PluginCallbackType2["onBeforeDataOut"] = "onBeforeDataOut";
  PluginCallbackType2["shouldSendToLogger"] = "shouldSendToLogger";
  PluginCallbackType2["onMetadataCalled"] = "onMetadataCalled";
  PluginCallbackType2["onBeforeMessageOut"] = "onBeforeMessageOut";
  PluginCallbackType2["onContextCalled"] = "onContextCalled";
  return PluginCallbackType2;
})(PluginCallbackType || {});
export {
  LogLevel,
  PluginCallbackType
};
